"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ChromeTraceEventsReporter", {
    enumerable: true,
    get: function() {
        return ChromeTraceEventsReporter;
    }
});
const _chalk = /*#__PURE__*/ _interop_require_default(require("chalk"));
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function hrTimeToMicroseconds(hr) {
    return hr[0] * 1e6 + hr[1] * 1e-3;
}
function getTimeBasedFilename(prefix) {
    const now = new Date(); // 2011-10-05T14:48:00.000Z
    const datetime = now.toISOString().split(".")[0]; // 2011-10-05T14:48:00
    const datetimeNormalized = datetime.replace(/-|:/g, ""); // 20111005T144800
    return `${prefix ? prefix + "-" : ""}${datetimeNormalized}.json`;
}
class ChromeTraceEventsReporter {
    log() {
    // pass
    }
    summarize(schedulerRunSummary) {
        const { targetRuns, startTime } = schedulerRunSummary;
        // categorize events
        const { categorize } = this.options;
        for (const targetRun of targetRuns.values()){
            // Skip hidden targets because those should be hidden by reporters.
            // Hiding as well skipped targets to avoid polluting the profile.
            if (targetRun.target.hidden || targetRun.status === "skipped") {
                continue;
            }
            const event = {
                name: targetRun.target.id,
                cat: `${targetRun.status}#${targetRun.target.task}`,
                ph: "X",
                ts: hrTimeToMicroseconds(targetRun.startTime) - hrTimeToMicroseconds(startTime),
                dur: hrTimeToMicroseconds(targetRun.duration ?? [
                    0,
                    1000
                ]),
                pid: 1,
                tid: targetRun.threadId
            };
            if (categorize) {
                event.cat += `,${categorize(targetRun)}`;
            }
            this.events.traceEvents.push(event);
        }
        // write events to stream
        this.logStream.write(JSON.stringify(this.events, null, 2));
        this.consoleLogStream.write(_chalk.default.blueBright(`\nProfiler output written to ${_chalk.default.underline(this.outputFile)}, open it with chrome://tracing or edge://tracing\n`));
    }
    constructor(options){
        _define_property(this, "options", void 0);
        _define_property(this, "logStream", void 0);
        _define_property(this, "consoleLogStream", void 0);
        _define_property(this, "events", void 0);
        _define_property(this, "outputFile", void 0);
        this.options = options;
        this.consoleLogStream = process.stdout;
        this.events = {
            traceEvents: [],
            displayTimeUnit: "ms"
        };
        this.outputFile = options.outputFile ?? getTimeBasedFilename("profile");
        if (!_fs.default.existsSync(_path.default.dirname(this.outputFile))) {
            _fs.default.mkdirSync(_path.default.dirname(this.outputFile), {
                recursive: true
            });
        }
        this.logStream = _fs.default.createWriteStream(this.outputFile, {
            flags: "w"
        });
    }
}
